
/**
 * Constantes para manejar los días de la semana, estos son los días de la
 * semana que maneja Fullcalendar, por lo tanto no modificarlos
 */
var DAYS_OF_WEEK = {
    MONDAY : 0,
    TUESDAY: 1,
    WEDNESDAY: 2,
    THURSDAY: 3,
    FRIDAY: 4,
    SATURDAY: 5,
    SUNDAY: 6
}

function utilFeeCalendar(){

    /*
     *  Configuración por defecto para los calendarios que manejan tarifas
     */
    var dayNames = ['Domingo', 'Lunes', 'Martes', 'Miercoles',
        'Jueves', 'Viernes', 'Sabado'];

    return{

        getFirstDay : function(){
            return 1;
        },

        getSlotDuration : function(){
            return '00:60:00';  
        },

        getDefaultDate : function(){
            return 'Mon Dec 1 2014 1:01:00 GMT-0500 (COT)'; //no cambiar esta feha, dado que se hacen cálculos a partir de este valor
        },

        getDefaultDateForCalendar : function(){
            return moment('2014-12-01T00:00:00'); //no cambiar esta feha, dado que se hacen cálculos a partir de este valor
        },

        getInitTime : function(){
            return '06:00'; 
        },

        getEndTime : function(){
            return '24:00'; // la última reserva termina a media noche
        },

        getDayNamesShort: function(){
            return ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];
        },

        getDayNames: function(){
            return dayNames;
        },

        getDefaultView: function(){
            return 'month';
        },

        getDayNameByNumber: function(pos){
            return dayNames[pos];
        },

        getYearFromMoment: function(mome){
            var d = parseInt(mome.format('d'));
            return d;
        },

        getMonthFromMoment: function(mome){
            var d = parseInt(mome.format('d'));
            return d;
        },

        getDayFromMoment: function(mome){
            var d = parseInt(mome.format('d'));
            return d;
        },

        getHourFromMoment: function(mom){
            var h = parseInt(mom.format('h'));
            return h;
        },

        getHour24FromMoment: function(mom){
            var h24 = parseInt(mom.format('H'));
            return h24;
        },

        getMeridiemFromMoment: function(mom){
            var m = mom.format('a');
            return m;
        }

    };
}